import { render, staticRenderFns } from "./BottomControlBlock.vue?vue&type=template&id=0d9700a9&scoped=true&"
import script from "./BottomControlBlock.vue?vue&type=script&lang=js&"
export * from "./BottomControlBlock.vue?vue&type=script&lang=js&"
import style0 from "./BottomControlBlock.vue?vue&type=style&index=0&id=0d9700a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9700a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VRow})
